exports = module.exports = require("../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*!\n\nCopyright 2017-present Palantir Technologies, Inc. All rights reserved.\nLicensed under the Apache License, Version 2.0.\n\n*/\n@font-face{\n  font-family:\"Icons16\";\n  font-weight:normal;\n  font-style:normal;\n  src:url(" + require("../../resources/icons/icons-16.eot") + "?#iefix) format(\"embedded-opentype\"), url(" + require("../../resources/icons/icons-16.woff") + ") format(\"woff\"), url(" + require("../../resources/icons/icons-16.ttf") + ") format(\"truetype\"); }\n\n@font-face{\n  font-family:\"Icons20\";\n  font-weight:normal;\n  font-style:normal;\n  src:url(" + require("../../resources/icons/icons-20.eot") + "?#iefix) format(\"embedded-opentype\"), url(" + require("../../resources/icons/icons-20.woff") + ") format(\"woff\"), url(" + require("../../resources/icons/icons-20.ttf") + ") format(\"truetype\"); }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/@blueprintjs/icons/lib/css/blueprint-icons.css
// module id = 339
// module chunks = 0